// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-indicator {\n  width: 100%;\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color:#dfcf77;\n}\n\n.error-indicator .error-indicator__message {\n  font-size: 1.7rem;\n  padding: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
